(function () {
  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var header = btn.closest('.site-header');
      var open = header.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Hero background video: force muted autoplay
  document.querySelectorAll('video[data-autoplay]').forEach(function (v) {
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
  });

  // Video chapters
  document.querySelectorAll('[data-chapter]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = document.getElementById(b.getAttribute('data-target'));
      if (!v) return;
      v.currentTime = parseFloat(b.getAttribute('data-chapter')) || 0;
      var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
    });
  });

  // Product gallery thumbs
  document.querySelectorAll('[data-product-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-main-image]');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-src');
        main.alt = t.getAttribute('data-alt') || '';
        main.removeAttribute('srcset');
        g.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // Variant picker: update hidden id + price + availability
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var btn = form.querySelector('[data-add]');
    function update() {
      var sel = [];
      form.querySelectorAll('[data-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
      });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout'); }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    form.addEventListener('change', function (e) { if (e.target.closest('[data-option]')) update(); });
  });

  // Gallery filters + lightbox
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-filter]');
    var items = root.querySelectorAll('[data-cat]');
    var videos = root.querySelector('[data-videos]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var f = t.getAttribute('data-filter');
        tabs.forEach(function (o) { o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
        items.forEach(function (i) { i.hidden = !(f === 'all' || i.getAttribute('data-cat') === f); });
        if (videos) videos.hidden = !(f === 'all' || f === 'videos');
        var grid = root.querySelector('[data-photos]'); if (grid) grid.hidden = f === 'videos';
      });
    });
    var dlg = root.querySelector('dialog');
    if (!dlg) return;
    var img = dlg.querySelector('img'), cap = dlg.querySelector('[data-caption]');
    var list = [], idx = 0;
    function show(i) {
      list = Array.prototype.filter.call(items, function (x) { return !x.hidden; });
      idx = (i + list.length) % list.length;
      var b = list[idx]; img.src = b.getAttribute('data-full'); img.alt = b.getAttribute('data-alt');
      cap.textContent = b.getAttribute('data-alt') + '  (' + (idx + 1) + ' / ' + list.length + ')';
    }
    items.forEach(function (b) {
      b.addEventListener('click', function () {
        var vis = Array.prototype.filter.call(items, function (x) { return !x.hidden; });
        show(vis.indexOf(b)); if (dlg.showModal) dlg.showModal();
      });
    });
    dlg.querySelector('[data-prev]').addEventListener('click', function () { show(idx - 1); });
    dlg.querySelector('[data-next]').addEventListener('click', function () { show(idx + 1); });
    dlg.querySelector('[data-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); });
  });
})();
